import { Component } from '@verndale/core';
import { CountUp } from 'countup.js';
import { inView } from 'motion';
import { initBorderAnimation } from '../helpers/index';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      statsNumber: [...this.el.querySelectorAll('.about-v2__stats span')],
      container: this.el.querySelector('.about-v2__stats'),
      items: [...this.el.querySelectorAll('.the-outcome-v2__stats-item')]
    };

    this.calculateChildren();
    this.start = false;
  }

  calculateChildren() {
    if (this.dom.container.children.length === 3) {
      this.dom.container.classList.add('has-multiple-children');
    }

    if (this.dom.container.children.length === 1) {
      this.dom.container.classList.add('has-one-children');
    }
  }

  addListeners() {
    window.addEventListener('scroll', ::this.startStats, false);
  }

  startStats() {
    this.dom.statsNumber.forEach(element => {
      inView(element, () => {
        if (!this.start) {
          this.start = true;
          setTimeout(() => this.initStats(), 500);
        }
      });
    });
  }

  initStats() {
    const options = {
      duration: 2,
      useGrouping: false
    };

    this.dom.statsNumber.forEach(stat => {
      initBorderAnimation(stat);
      if (!stat.dataset.number) return;
      const demo = new CountUp(stat, Number(stat.dataset.number), options);
      if (demo.error) {
        return console.error(demo.error);
      }
      demo.start();
    });
  }
}

export default Module;
